import { isValidPhoneNumber } from "libphonenumber-js";
import moment from "moment";
import { ValidatorForm } from "react-material-ui-form-validator";

export const applyValidationRules = () => {
    ValidatorForm.addValidationRule("isValidDate", (value) => {
        return moment(value, "DD/MM/YYYY", true).isValid();
    });

    ValidatorForm.addValidationRule("isValidDay", (value) => {
        const num = parseInt(value, 10);
        return value === "" || (num >= 1 && num <= 31);
    });

    ValidatorForm.addValidationRule("isValidMonth", (value) => {
        const num = parseInt(value, 10);
        return value === "" || (num >= 1 && num <= 12);
    });

    ValidatorForm.addValidationRule("isValidYear", (value) => {
        return value === "" || value.length === 4;
    });

    ValidatorForm.addValidationRule("isLessThan100", (value) => {
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 100;

        const year = parseInt(value, 10);

        if (isNaN(year)) {
            return false; 
        }

        if (year < minYear) {
            return false; 
        }

        return true; 
    });

    ValidatorForm.addValidationRule("isMoreThan18", (value) => {
        const currentYear = new Date().getFullYear();
        const maxYear = currentYear - 18;

        const year = parseInt(value, 10);

        if (isNaN(year)) {
            return false;
        }

        if (year > maxYear) {
            return false; 
        }

        return true; 
    });

    ValidatorForm.addValidationRule("isNotInFuture", (value) => {
        const parsedDate = moment(value, "DD/MM/YYYY", true);
        return parsedDate.isValid() && parsedDate.isSameOrBefore(moment());
    });

    ValidatorForm.addValidationRule("isAdult", (value) => {
        const parsedDate = moment(value, "DD/MM/YYYY", true);
        const eighteenYearsAgo = moment().subtract(18, "years");
        return parsedDate.isValid() && parsedDate.isSameOrBefore(eighteenYearsAgo);
    });

    ValidatorForm.addValidationRule("isRequiredToggle", (value) => {
        return !!value;
    });

    ValidatorForm.addValidationRule("isSliderValid", (value) => {
        return value > 0;
    });

    ValidatorForm.addValidationRule("isAutocompleteValid", (value) => {
        return !!value;
    });

    ValidatorForm.addValidationRule('isValidDateGroup', (value) => {
        const [day, month, year] = value.split('/').map(Number);
        const date = new Date(year, month - 1, day);

        const isValid =
            day > 0 &&
            month > 0 &&
            month <= 12 &&
            year > 1900 &&
            date.getDate() === day &&
            date.getMonth() === month - 1 &&
            date.getFullYear() === year;

        return isValid;
    });

    ValidatorForm.addValidationRule("isValidPhoneNumber", (value: string) => {
        if (!value) return false;

        const normalized = value.replace(/[^\d]/g, "");

        return (
            normalized.length >= 7 &&
            normalized.length <= 15
        );
    });


};


export const removeValidationRules = () => {
    ValidatorForm.removeValidationRule("isValidDate");
    ValidatorForm.removeValidationRule("isValidDay");
    ValidatorForm.removeValidationRule("isValidMonth");
    ValidatorForm.removeValidationRule("isValidYear");
    ValidatorForm.removeValidationRule("isNotFutureDate");
    ValidatorForm.removeValidationRule("isAdult");
    ValidatorForm.removeValidationRule("isMoreThan18");
    ValidatorForm.removeValidationRule("isLessThan100")
    ValidatorForm.removeValidationRule("isRequiredToggle");
    ValidatorForm.removeValidationRule("isSliderValid");
    ValidatorForm.removeValidationRule("isAutocompleteValid");
    ValidatorForm.removeValidationRule("isRadioSelected");
    ValidatorForm.removeValidationRule("isValidDateGroup");
    ValidatorForm.removeValidationRule("isValidPhoneNumber");
};
